import _ from 'lodash';

export const RESET_REVIEWING_REPORT = "[MIS] RESET_REVIEWING_REPORT";

export const VIEW_WORKLIST_VISIT = "[MIS] VIEW_WORKLIST_VISIT";
export const VIEW_WORKLIST_VISIT_START = "[MIS] VIEW_WORKLIST_VISIT_START";
export const VIEW_WORKLIST_VISIT_SUCCESS = "[MIS] VIEW_WORKLIST_VISIT_SUCCESS";
export const VIEW_WORKLIST_VISIT_ERROR = "[MIS] VIEW_WORKLIST_VISIT_ERROR";

export const VIEW_SUBMITTED_FOR_VERIFICATION_VISIT = "[MIS] VIEW_SUBMITTED_FOR_VERIFICATION_VISIT";
export const VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_START = "[MIS] VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_START";
export const VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS = "[MIS] VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS";
export const VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_ERROR = "[MIS] VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_ERROR";

export const VIEW_PARKED_VISIT = "[MIS] VIEW_PARKED_VISIT";
export const VIEW_PARKED_VISIT_START = "[MIS] VIEW_PARKED_VISIT_START";
export const VIEW_PARKED_VISIT_SUCCESS = "[MIS] VIEW_PARKED_VISIT_SUCCESS";
export const VIEW_PARKED_VISIT_ERROR = "[MIS] VIEW_PARKED_VISIT_ERROR";

export const VIEW_VERIFIED_VISIT = "[MIS] VIEW_VERIFIED_VISIT";
export const VIEW_VERIFIED_VISIT_START = "[MIS] VIEW_VERIFIED_VISIT_START";
export const VIEW_VERIFIED_VISIT_SUCCESS = "[MIS] VIEW_VERIFIED_VISIT_SUCCESS";
export const VIEW_VERIFIED_VISIT_ERROR = "[MIS] VIEW_VERIFIED_VISIT_ERROR";

export const VIEW_SUBMITTED_TO_TYPIST_VISIT = "[MIS] VIEW_SUBMITTED_TO_TYPIST_VISIT";
export const VIEW_SUBMITTED_TO_TYPIST_VISIT_START = "[MIS] VIEW_SUBMITTED_TO_TYPIST_VISIT_START";
export const VIEW_SUBMITTED_TO_TYPIST_VISIT_SUCCESS = "[MIS] VIEW_SUBMITTED_TO_TYPIST_VISIT_SUCCESS";
export const VIEW_SUBMITTED_TO_TYPIST_VISIT_ERROR = "[MIS] VIEW_SUBMITTED_TO_TYPIST_VISIT_ERROR";

export const UNLOCK_VISIT = "[MIS] UNLOCK_VISIT";
export const UNLOCK_VISIT_SUCCESS = "[MIS] UNLOCK_VISIT_SUCCESS";
export const UNLOCK_VISIT_ERROR = "[MIS] UNLOCK_VISIT_ERROR";
export const UNLOCK_VISIT_START = "[MIS] UNLOCK_VISIT_START";

export const LOCK_VERIFIED_VISIT = "[MIS] LOCK_VERIFIED_VISIT";
export const LOCK_VERIFIED_VISIT_START = "[MIS] LOCK_VERIFIED_VISIT_START";
export const LOCK_VERIFIED_VISIT_SUCCESS = "[MIS] LOCK_VERIFIED_VISIT_SUCCESS";
export const LOCK_VERIFIED_VISIT_ERROR = "[MIS] LOCK_VERIFIED_VISIT_ERROR";

export const UPDATE_VISIT_REPORT_STATE = "[MIS] UPDATE_VISIT_REPORT_STATE";
export const UPDATE_VISIT_REPORT_STATE_START = "[MIS] UPDATE_VISIT_REPORT_STATE_START";
export const UPDATE_VISIT_REPORT_STATE_SUCCESS = "[MIS] UPDATE_VISIT_REPORT_STATE_SUCCESS";
export const UPDATE_VISIT_REPORT_STATE_ERROR = "[MIS] UPDATE_VISIT_REPORT_STATE_ERROR";

export const FETCH_PATIENT_HISTORY_REPORTS = "[MIS] FETCH_PATIENT_HISTORY_REPORTS";
export const FETCH_PATIENT_HISTORY_REPORTS_START = "[MIS] FETCH_PATIENT_HISTORY_REPORTS_START";
export const FETCH_PATIENT_HISTORY_REPORTS_SUCCESS = "[MIS] FETCH_PATIENT_HISTORY_REPORTS_SUCCESS";
export const FETCH_PATIENT_HISTORY_REPORTS_ERROR = "[MIS] FETCH_PATIENT_HISTORY_REPORTS_ERROR";

export const UPDATE_TICKET_ID = "[MIS] UPDATE_TICKET_ID";

export const SAVE_VISIT_REPORT_DICTATION = "[MIS] SAVE_VISIT_REPORT_DICTATION";
export const SAVE_VISIT_REPORT_DICTATION_SUCCESS = "[MIS] SAVE_VISIT_REPORT_DICTATION_SUCCESS";

export const SUBMIT_VISIT_REPORT_DICTATION = "[MIS] SUBMIT_VISIT_REPORT_DICTATION";
export const SUBMIT_VISIT_REPORT_DICTATION_START = "[MIS] SUBMIT_VISIT_REPORT_DICTATION_START";
export const SUBMIT_VISIT_REPORT_DICTATION_SUCCESS = "[MIS] SUBMIT_VISIT_REPORT_DICTATION_SUCCESS";
export const SUBMIT_VISIT_REPORT_DICTATION_ERROR = "[MIS] SUBMIT_VISIT_REPORT_DICTATION_ERROR";

export const SAVE_DICTATION_AUDIO = "[MIS] SAVE_DICTATION_AUDIO";
export const SAVE_DICTATION_AUDIO_START = "[MIS] SAVE_DICTATION_AUDIO_START";
export const SAVE_DICTATION_AUDIO_SUCCESS = "[MIS] SAVE_DICTATION_AUDIO_SUCCESS";
export const SAVE_DICTATION_AUDIO_ERROR = "[MIS] SAVE_DICTATION_AUDIO_ERROR";
export const SET_DICTATION_AUDIO_UPLOAD_PROGRESS = "[MIS] SET_DICTATION_AUDIO_UPLOAD_PROGRESS";

export const SKIP_CURRENT_AND_VIEW_NEXT_VISIT = "[MIS] SKIP_CURRENT_AND_VIEW_NEXT_VISIT";

export const UNASSIGN_MIS1 = "[MIS] UNASSIGN_MIS1";
export const UNASSIGN_MIS1_START = "[MIS] UNASSIGN_MIS1_START";
export const UNASSIGN_MIS1_SUCCESS = "[MIS] UNASSIGN_MIS1_SUCCESS";
export const UNASSIGN_MIS1_ERROR = "[MIS] UNASSIGN_MIS1_ERROR";

export const ASSIGN_MIS2_TO_VISIT = "[MIS] ASSIGN_MIS2_TO_VISIT";
export const ASSIGN_MIS2_TO_VISIT_SUCCESS = "[MIS] ASSIGN_MIS2_TO_VISIT_SUCCESS";
export const ASSIGN_MIS2_TO_VISIT_ERROR = "[MIS] ASSIGN_MIS2_TO_VISIT_ERROR";


export const UPDATE_STUDY = "[MIS] UPDATE_STUDY";
export const UPDATE_STUDY_SUCCESS = "[MIS] UPDATE_STUDY_SUCCESS";
export const UPDATE_STUDY_ERROR = "[MIS] UPDATE_STUDY_ERROR";

export const ADD_REPORT_DIAGRAM_SUCCESS = "[MIS] ADD_REPORT_DIAGRAM_SUCCESS";

export const OPEN_VOYAGER_STUDY = 'OPEN_VOYAGER_STUDY';
export const CLOSE_VOYAGER_STUDY = 'CLOSE_VOYAGER_STUDY';

export const viewWorklistVisit = (report, stayOnViewer = false) => {
    return {
        type: VIEW_WORKLIST_VISIT,
        report,
        stayOnViewer
    };
};

export const viewSubmittedForVerificationVisit = (report) => {
    return {
        type: VIEW_SUBMITTED_FOR_VERIFICATION_VISIT,
        report
    };
};

export const viewParkedVisit = (report) => {
    return {
        type: VIEW_PARKED_VISIT,
        report
    };
};

export const viewVerifiedVisit = (report) => {
    return {
        type: VIEW_VERIFIED_VISIT,
        report
    };
};

export const viewSubmittedToTypistVisit = (report) => {
    return {
        type: VIEW_SUBMITTED_TO_TYPIST_VISIT,
        report
    };
};


export const resetReviewingReport = () => {
    return {
        type: RESET_REVIEWING_REPORT,
    };
}

export const updateVisitReportState = (updateReportData, autoNextConfig) => {
    return {
        type: UPDATE_VISIT_REPORT_STATE,
        payload: {
            updateReportData,
            autoNextConfig
        },
    };
}

export const fetchPatientHistoryReports = (visit) => {
    return {
        type: FETCH_PATIENT_HISTORY_REPORTS,
        visit,
    };
}

export const unlockVisit = (visit, onConfirm) => {
    return {
        type: UNLOCK_VISIT,
        payload: {
            visit,
            onConfirm
        }
    };
}

export const submitVisitReportDictation = (dictation, autoNextConfig) => (dispatch) => {
    dispatch({
        type: SUBMIT_VISIT_REPORT_DICTATION,
        payload: {
            dictation,
            autoNextConfig,
            dispatch
        }
    })
}

export const saveDictationAudio = (dictation) => (dispatch) => {
    dispatch({
        type: SAVE_DICTATION_AUDIO,
        payload: {
            dictation,
            dispatch
        }
    })
}

export const skipCurrentAndLoadNextVisit = (visit, autoNextConfig) => {
    return {
        type: SKIP_CURRENT_AND_VIEW_NEXT_VISIT,
        payload: {
            visit,
            autoNextConfig
        }
    }
}

export const unassignMis1 = (reportId) => {
    return {
        type: UNASSIGN_MIS1,
        reportId
    };
}

export const assignedMis2 = (payload) => {
    return {
        type: ASSIGN_MIS2_TO_VISIT,
        payload
    };
}

export const updateMisStudy = (payload) => {
    return {
        type: UPDATE_STUDY,
        payload
    };
}

export const lockVerifiedVisit = (report, enableCkEditor) => {
    return {
        type: LOCK_VERIFIED_VISIT,
        report,
        enableCkEditor
    };
};

export const addReportDiagram = (diagram) => {
    return {
        type: ADD_REPORT_DIAGRAM_SUCCESS,
        'diagram': diagram
    }
}

export const openVoyagerStudy = (accessionNumber) => ({
    type: OPEN_VOYAGER_STUDY,
    accessionNumber
});

export const closeVoyagerStudy = (accessionNumber, isReported) => ({
    type: CLOSE_VOYAGER_STUDY,
    accessionNumber,
    isReported
});
